import { render, staticRenderFns } from "./InvoicePreview.vue?vue&type=template&id=23f23db6&scoped=true"
import script from "./InvoicePreview.vue?vue&type=script&lang=js"
export * from "./InvoicePreview.vue?vue&type=script&lang=js"
import style0 from "./InvoicePreview.vue?vue&type=style&index=0&id=23f23db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f23db6",
  null
  
)

export default component.exports